import { useCallback, useEffect, useRef, useState } from 'react'

import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { FormPedidosCompra } from '../../components/Forms/FormPedidosCompra'
import PedidosCompraService from '../../services/database/PedidosCompraService'

export function EditarPedidoCompra() {
  const [isLoadingRequest, setIsLoadingRequest] = useState(false)
  const [isLoadingOrder, setIsLoadingOrder] = useState(true)

  const formPedidosCompraRef = useRef(null)

  const params = useParams()

  async function handleSubmit() {
    try {
      setIsLoadingRequest(true)

      if (formPedidosCompraRef.current) {
        const { order, products, duplicatas } =
          formPedidosCompraRef?.current?.getDataForm()

        await PedidosCompraService.update(params.id, {
          order,
          products,
          duplicatas,
        })

        toast.success(`Pedido de compra atualizado com sucesso!`)
      }
    } catch (err) {
      console.log(`Erro ao criar o pedido de compra: ${err}`)

      toast.error(`Não foi possível criar o pedido de compra!`)
    } finally {
      setIsLoadingRequest(false)
    }
  }

  const loadPedidoCompra = useCallback(async () => {
    try {
      setIsLoadingOrder(true)

      const { pedidoCompra, products, duplicatas } =
        await PedidosCompraService.getById(params.id)

      if (formPedidosCompraRef.current) {
        formPedidosCompraRef.current.setDataForm(
          pedidoCompra,
          products,
          duplicatas,
        )
      }
    } catch (err) {
      console.log(`Erro ao carregar o pedido de compra: ${err}`)
      toast.error('Não foi possível carregar o pedido de compra!')
    } finally {
      setIsLoadingOrder(false)
    }
  }, [params.id])

  useEffect(() => {
    loadPedidoCompra()
  }, [loadPedidoCompra])

  return (
    <FormPedidosCompra
      ref={formPedidosCompraRef}
      idPedidoCompra={params.id}
      title="Editar Pedido de Compra"
      onSubmit={handleSubmit}
      isLoadingRequest={isLoadingRequest}
      isLoadingOrder={isLoadingOrder}
    />
  )
}
